// extracted by mini-css-extract-plugin
module.exports = {"next":"Next_next__8ts4G","secondLine":"Next_secondLine__uMm4x"};